import React, { useEffect, useMemo, useState } from 'react'
import { ExplainedResult } from './models'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import {
  selectResultExplainerAiFeatureId,
  selectResultExplainerIsLoading,
  selectResultExplainerResult,
  selectResultExplainerResultContext,
  selectResultExplainerResultListData,
  setResultExplainerResultContext,
} from '../../../../../store/meetingSummary/meetingSupport'
import { selectAiFeatures } from '../../../../../store/meetingSummary/aiFeatures'
import { selectAiFeaturePresets } from '../../../../../store/meetingSummary/aiFeaturePresets'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { useExplainResult } from '../hooks/api'
import { ResultExplainerView } from './ResultExplainerView'

import './ResultExplainer.scss'

export const ResultExplainer: React.FC = () => {
  const aiFeatureId = useAppSelector(selectResultExplainerAiFeatureId)
  const resultToExplain = useAppSelector(selectResultExplainerResult)
  const roomSession = useAppSelector(selectRoomSession)
  const aiFeatures = useAppSelector(selectAiFeatures)
  const aiFeaturePresets = useAppSelector(selectAiFeaturePresets)
  const isExplainResultLoading = useAppSelector(selectResultExplainerIsLoading)
  const resultContext = useAppSelector(selectResultExplainerResultContext)
  const resultListData = useAppSelector(selectResultExplainerResultListData)
  const dispatch = useAppDispatch()

  const explainResult = useExplainResult()

  const [explanationResult, setExplanationResult] = useState<ExplainedResult | null>(null)

  const aiFeaturePresetDescription = useMemo(() => {
    const aiFeature = aiFeatures.find((aiFeature) => aiFeature.id === aiFeatureId)
    const aiFeaturePreset = aiFeaturePresets.find((aiFeaturePreset) => aiFeaturePreset.id === aiFeature?.preset?.id)
    return aiFeaturePreset?.description ?? ''
  }, [aiFeatureId, aiFeatures, aiFeaturePresets])

  useEffect(() => {
    if (!resultToExplain) {
      return
    }
    if (aiFeaturePresetDescription) {
      dispatch(setResultExplainerResultContext(aiFeaturePresetDescription))
    }
    const executeExplainResult = async () => {
      const explanationResult = await explainResult(resultToExplain, resultContext ?? '')
      setExplanationResult(explanationResult)
    }
    executeExplainResult()
  }, [aiFeaturePresetDescription, dispatch, explainResult, resultContext, resultToExplain])

  return (
    <ResultExplainerView
      resultToExplain={resultToExplain ?? ''}
      resultListData={resultListData}
      explanationResult={explanationResult}
      isLoading={isExplainResultLoading}
      roomSession={roomSession}
    />
  )
}
